/* tslint:disable */
/* eslint-disable */
/**
 * Vayu API
 * The Vayu API is a RESTful API that allows you to submit events for processing and storage & manage billing related entities.           The API is secured using the Bearer Authentication scheme with JWT tokens.           To obtain a JWT token, please contact Vayu at team@withvayu.com
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dev@withvayu.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ContractStatus = {
    Active: 'Active',
    Inactive: 'Inactive',
    Terminated: 'Terminated',
    PendingTermination: 'PendingTermination',
    Error: 'Error'
} as const;
export type ContractStatus = typeof ContractStatus[keyof typeof ContractStatus];


export function ContractStatusFromJSON(json: any): ContractStatus {
    return ContractStatusFromJSONTyped(json, false);
}

export function ContractStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractStatus {
    return json as ContractStatus;
}

export function ContractStatusToJSON(value?: ContractStatus | null): any {
    return value as any;
}

